import React, { PureComponent } from 'react';
import { Form, Slider, Radio } from 'antd';
import { FormItemLayout, ConfigFormDecorator } from '../../tools';
import ShowcaseLayout from './showcase-layout';
import './index.less';
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
/**
 * 辅助橱窗-配置表单
 */

class showcase extends PureComponent<any> {
    changeStyle = (e) => {
        const newValue = e.target.value;
        const {
            form: { setFieldsValue },
        } = this.props;
        setFieldsValue({ entry: new Array(3), showStyle: newValue });
    };
    render() {
        const {
            form: { getFieldDecorator, getFieldValue },
            uploadAction,
            sourceRoot,
            linkTypes,
            linkTypeMode,
            selector,
        } = this.props;
        const formItemLayout = FormItemLayout;
        return (
            <Form className="showcase-form">
                <FormItem {...formItemLayout} label="选择模板">
                    {getFieldDecorator(
                        'showStyle',
                        {}
                    )(
                        <RadioGroup className="show-style" onChange={this.changeStyle}>
                            <Radio value={'1'}>
                                <img
                                    className="select-img"
                                    src="./images/editor/showcase-1.png"
                                    alt=""
                                />
                                <span className="select-title">2左2右</span>
                            </Radio>
                            <Radio value={'2'}>
                                <img
                                    className="select-img"
                                    src="./images/editor/showcase-2.png"
                                    alt=""
                                />
                                <span className="select-title">1左2右</span>
                            </Radio>
                            <Radio value={'3'}>
                                <img
                                    className="select-img"
                                    src="./images/editor/showcase-3.png"
                                    alt=""
                                />
                                <span className="select-title">1上2下</span>
                            </Radio>
                            <Radio value={'4'}>
                                <img
                                    className="select-img"
                                    src="./images/editor/showcase-4.png"
                                    alt=""
                                />
                                <span className="select-title">1左3右</span>
                            </Radio>
                        </RadioGroup>
                    )}
                </FormItem>
                <FormItem {...formItemLayout} label="布局">
                    {getFieldDecorator('entry', { initialValue: new Array(4) })(
                        <ShowcaseLayout
                            uploadAction={uploadAction}
                            sourceRoot={sourceRoot}
                            selector={selector}
                            linkTypes={linkTypes}
                            linkTypeMode={linkTypeMode}
                            showStyle={getFieldValue('showStyle')}
                        />
                    )}
                </FormItem>

                <FormItem {...formItemLayout} label={'高度比例'}>
                    {getFieldDecorator('height', { initialValue: 200 })(
                        <Slider max={350} min={40} />
                    )}
                </FormItem>

                <FormItem {...formItemLayout} label="图片间隙">
                    {getFieldDecorator('imgMargin')(<Slider max={80} min={0} />)}
                </FormItem>
                <FormItem {...formItemLayout} label="页面间距">
                    {getFieldDecorator('margin')(<Slider max={80} min={0} />)}
                </FormItem>
            </Form>
        );
    }
}

export const Showcase = ConfigFormDecorator(showcase);
